<lib-content-highlight-widget
  class="content-highlight-block"
  [title]="block?.title"
  [items]="items"
  [textColor]="block?.textColor"
  [langcode]="block?.langcode"
  [sliderEnabled]="block?.sliderEnabled"
  [mobileCardStyle]="block?.mobileCardStyle"
  [isPaymentEnabled]="isPaymentEnabled"
  [courseDetailsEnabled]="courseDetailsEnabled"
  (openDetails)="openDetails($event)"
  (navigateToEntity)="navigate($event)">
</lib-content-highlight-widget>
